export const statusText = (message: string): void => {
  const element = document.querySelector('#status-text') as HTMLDivElement | undefined;
  if (element) {
    element.style.animation = 'none';
    element.innerHTML = message;
    void element.offsetHeight; /* trigger reflow */
    element.style.animation = '';
  }
};
